const MINUTO = 60_000;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

/**
 * "há 3 horas" a partir de um instante ISO e de um "agora" injetado.
 * O relógio fica na tela, para o teste não depender da hora em que roda.
 */
export function tempoRelativo(iso: string, agoraMs: number): string {
  const instante = Date.parse(iso);
  if (Number.isNaN(instante)) return "há instantes";
  const delta = agoraMs - instante;
  if (delta < MINUTO) return "há instantes";
  if (delta < HORA) {
    const minutos = Math.floor(delta / MINUTO);
    return minutos === 1 ? "há 1 minuto" : `há ${minutos} minutos`;
  }
  if (delta < DIA) {
    const horas = Math.floor(delta / HORA);
    return horas === 1 ? "há 1 hora" : `há ${horas} horas`;
  }
  const dias = Math.floor(delta / DIA);
  return dias === 1 ? "há 1 dia" : `há ${dias} dias`;
}
